import { render, staticRenderFns } from "./UpdateTopics.vue?vue&type=template&id=85d54486&scoped=true"
import script from "./UpdateTopics.vue?vue&type=script&lang=js"
export * from "./UpdateTopics.vue?vue&type=script&lang=js"
import style0 from "./UpdateTopics.vue?vue&type=style&index=0&id=85d54486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d54486",
  null
  
)

export default component.exports